export default store => {
  return {
    async getGenre(params) {
      return await store.dispatch(`genres/fetch`, {
        type: "genre",
        params
      });
    },
    async getGenres(params) {
      return await store.dispatch("genres/fetch", {
        params
      });
    },
    async getTracksByGenre(params) {
      return await store.dispatch(`genres/tracks`, {
        params
      });
    },
    async getGenreYears(params) {
      return await store.dispatch(`genres/years`, {
        params
      });
    },
    async getAlbumsByGenre(params) {
      return await store.dispatch(`genres/albums`, {
        params
      });
    },
    async getArtistsByGenre(params) {
      return await store.dispatch(`genres/artists`, {
        params
      });
    }
  };
};
